import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from 'ui/hooks/useAuth';

const RequiredAuth: FC<PropsWithChildren> = (props) => {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) return <Navigate to={'/first-loan/register'} />;

  return <>{props.children}</>;
};

export default RequiredAuth;
